'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');

var emailRegex = /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,}$/i;

module.exports = buildSimpleValidator(function (value) {
  return emailRegex.test(value);
}, 'Value must be an email address');